export enum  WarrantyOperationType {
    activation = 1,
    return = 2,
    correction = 3,
    update = 4,
    extension = 5
}